import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import PageMeta from "./PageMeta";

function PixelMockup() {
  return (
    <div className="relative mx-auto" style={{ width: "150px" }}>
      {/* Body */}
      <div
        className="relative rounded-[2rem] bg-slate-800 shadow-2xl shadow-cyan-400/20"
        style={{ border: "5px solid #334155", paddingTop: "14px", paddingBottom: "14px" }}
      >
        {/* Punch-hole camera */}
        <div className="flex justify-center mb-2">
          <div
            className="rounded-full bg-slate-900"
            style={{ width: "10px", height: "10px", border: "1px solid #475569" }}
          />
        </div>
        {/* Screen */}
        <div className="mx-1.5 rounded-lg overflow-hidden" style={{ height: "190px", background: "#0f172a" }}>
          {/* Chrome address bar */}
          <div style={{ background: "#1e293b", padding: "5px 6px" }}>
            <div
              className="flex items-center gap-1 rounded-full"
              style={{ background: "#0f172a", padding: "3px 7px" }}
            >
              <span style={{ fontSize: "5px", color: "#94a3b8" }}>🔒</span>
              <span style={{ fontSize: "5px", color: "#94a3b8", letterSpacing: "0" }}>
                redruthseaangling...
              </span>
              <div style={{ marginLeft: "auto" }}>
                <div style={{ width: "2px", height: "2px", borderRadius: "50%", background: "#64748b" }} />
                <div style={{ width: "2px", height: "2px", borderRadius: "50%", background: "#64748b", marginTop: "1px" }} />
                <div style={{ width: "2px", height: "2px", borderRadius: "50%", background: "#64748b", marginTop: "1px" }} />
              </div>
            </div>
          </div>
          {/* Page content */}
          <div className="flex flex-col items-center justify-center" style={{ height: "155px" }}>
            <span style={{ fontSize: "10px", color: "#22d3ee", fontWeight: "bold", letterSpacing: "0.05em" }}>
              RSAA
            </span>
            <span style={{ fontSize: "5px", color: "#64748b", marginTop: "3px" }}>
              Redruth Sea Angling
            </span>
          </div>
        </div>
        {/* Android nav buttons */}
        <div className="flex justify-center items-center gap-5 mt-2.5">
          <div style={{ width: "6px", height: "6px", borderRadius: "50%", border: "1.5px solid #475569" }} />
          <div style={{ width: "8px", height: "8px", border: "1.5px solid #475569", borderRadius: "2px" }} />
          <div
            style={{
              width: 0,
              height: 0,
              borderTop: "5px solid transparent",
              borderBottom: "5px solid transparent",
              borderRight: "7px solid #475569",
            }}
          />
        </div>
      </div>
      {/* Power button */}
      <div
        className="absolute rounded-r"
        style={{ right: "-6px", top: "56px", width: "5px", height: "32px", background: "#334155" }}
      />
      {/* Volume buttons */}
      <div
        className="absolute rounded-l"
        style={{ left: "-6px", top: "44px", width: "5px", height: "20px", background: "#334155" }}
      />
      <div
        className="absolute rounded-l"
        style={{ left: "-6px", top: "70px", width: "5px", height: "20px", background: "#334155" }}
      />
      <p className="mt-3 text-center text-xs font-semibold text-slate-400">Google Pixel (Android)</p>
    </div>
  );
}

function IPhoneMockup() {
  return (
    <div className="relative mx-auto" style={{ width: "150px" }}>
      {/* Body */}
      <div
        className="relative bg-slate-700 shadow-2xl shadow-purple-400/20"
        style={{
          border: "5px solid #475569",
          borderRadius: "2.8rem",
          paddingTop: "14px",
          paddingBottom: "14px",
        }}
      >
        {/* Dynamic Island */}
        <div className="flex justify-center mb-2">
          <div
            className="rounded-full bg-slate-900"
            style={{ width: "44px", height: "14px" }}
          />
        </div>
        {/* Screen */}
        <div className="mx-1.5 rounded-lg overflow-hidden" style={{ height: "190px", background: "#0f172a" }}>
          {/* Safari address bar */}
          <div style={{ background: "#1e293b", padding: "5px 6px" }}>
            <div
              className="rounded-full text-center"
              style={{ background: "#0f172a", padding: "3px 7px", fontSize: "5px", color: "#94a3b8" }}
            >
              redruthseaangling...
            </div>
          </div>
          {/* Page content */}
          <div className="flex flex-col items-center justify-center" style={{ height: "136px" }}>
            <span style={{ fontSize: "10px", color: "#22d3ee", fontWeight: "bold", letterSpacing: "0.05em" }}>
              RSAA
            </span>
            <span style={{ fontSize: "5px", color: "#64748b", marginTop: "3px" }}>
              Redruth Sea Angling
            </span>
          </div>
          {/* Safari bottom toolbar */}
          <div
            className="flex items-center justify-around"
            style={{ background: "#1e293b", padding: "4px 8px" }}
          >
            {["‹", "›", "⬡", "⧉", "⋯"].map((icon, i) => (
              <span key={i} style={{ fontSize: i === 2 ? "8px" : "7px", color: "#64748b" }}>
                {icon}
              </span>
            ))}
          </div>
        </div>
        {/* Home indicator */}
        <div className="flex justify-center mt-2.5">
          <div style={{ width: "50px", height: "4px", borderRadius: "9999px", background: "#475569" }} />
        </div>
      </div>
      {/* Power button */}
      <div
        className="absolute rounded-r"
        style={{ right: "-6px", top: "52px", width: "5px", height: "32px", background: "#475569" }}
      />
      {/* Silent switch */}
      <div
        className="absolute rounded-l"
        style={{ left: "-6px", top: "36px", width: "5px", height: "14px", background: "#475569" }}
      />
      {/* Volume buttons */}
      <div
        className="absolute rounded-l"
        style={{ left: "-6px", top: "58px", width: "5px", height: "22px", background: "#475569" }}
      />
      <div
        className="absolute rounded-l"
        style={{ left: "-6px", top: "86px", width: "5px", height: "22px", background: "#475569" }}
      />
      <p className="mt-3 text-center text-xs font-semibold text-slate-400">iPhone</p>
    </div>
  );
}

const steps = [
  {
    id: "android",
    label: "Android",
    browser: "Chrome",
    color: "cyan",
    icon: "three dots",
    instructions: [
      { step: 1, text: "Open the site in Chrome." },
      { step: 2, text: 'Tap the three dots ( ⋮ ) in the top-right corner.' },
      { step: 3, text: 'Select "Add to Home screen".' },
      { step: 4, text: 'Confirm or edit the name, then tap "Add".' },
    ],
  },
  {
    id: "ios-safari",
    label: "iPhone",
    browser: "Safari",
    color: "sky",
    instructions: [
      { step: 1, text: "Open the site in Safari." },
      { step: 2, text: "Tap the Share button ( the square with an arrow at the bottom of the screen )." },
      { step: 3, text: 'Scroll down and tap "Add to Home Screen".' },
      { step: 4, text: 'Confirm or adjust the name, then tap "Add".' },
    ],
  },
  {
    id: "ios-chrome",
    label: "iPhone",
    browser: "Chrome",
    color: "indigo",
    instructions: [
      { step: 1, text: "Open the site in Chrome." },
      { step: 2, text: 'Tap the three dots ( ... ) in the bottom-right corner.' },
      { step: 3, text: 'Select "Add to Home Screen".' },
      { step: 4, text: 'Adjust the name if you wish, then tap "Add".' },
    ],
  },
];

const colorMap = {
  cyan: {
    badge: "bg-cyan-400/10 text-cyan-300 border-cyan-300/30",
    num: "bg-cyan-400/10 text-cyan-300",
    border: "border-cyan-300/20",
    dot: "bg-cyan-400",
  },
  sky: {
    badge: "bg-sky-400/10 text-sky-300 border-sky-300/30",
    num: "bg-sky-400/10 text-sky-300",
    border: "border-sky-300/20",
    dot: "bg-sky-400",
  },
  indigo: {
    badge: "bg-indigo-400/10 text-indigo-300 border-indigo-300/30",
    num: "bg-indigo-400/10 text-indigo-300",
    border: "border-indigo-300/20",
    dot: "bg-indigo-400",
  },
};

export default function BookmarkPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Add RSAA to Your Home Screen | Redruth Sea Angling Association"
        description="Save the Redruth Sea Angling Association website as an app-style shortcut on your phone for quick access."
        url="https://www.redruthseaanglingassociation.co.uk/install"
      />

      {/* Hero */}
      <div className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950" />
        {/* Subtle glow blobs */}
        <div className="pointer-events-none absolute -top-32 left-1/4 h-72 w-72 rounded-full bg-cyan-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -top-16 right-1/4 h-64 w-64 rounded-full bg-indigo-500/10 blur-3xl" />

        <div className="relative mx-auto max-w-4xl px-6 py-16 sm:px-8 sm:py-20 text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-cyan-300/30 bg-cyan-400/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-cyan-300 mb-6">
            <Smartphone className="h-3.5 w-3.5" />
            Mobile Guide
          </div>
          <h1 className="heading-glow text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Add to Your Home Screen
          </h1>
          <p className="mt-4 text-base leading-7 text-slate-400 sm:text-lg max-w-xl mx-auto">
            Save the RSAA website as an app-style shortcut on your phone for quick access — no App Store needed.
          </p>

          {/* Phone mockups */}
          <div className="mt-12 flex justify-center gap-10 sm:gap-16">
            <PixelMockup />
            <IPhoneMockup />
          </div>
        </div>
      </div>

      {/* Instructions */}
      <div className="mx-auto max-w-3xl px-6 pb-20 pt-12 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20 mb-10"
        >
          ← Back
        </Link>

        <div className="space-y-8">
          {steps.map(({ id, label, browser, color, instructions }) => {
            const c = colorMap[color];
            return (
              <div
                key={id}
                className={`rounded-[2rem] border bg-slate-900/80 p-8 backdrop-blur ${c.border}`}
              >
                <div className="flex items-center gap-3 mb-6">
                  <span className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-bold uppercase tracking-widest ${c.badge}`}>
                    <span
                      className={`h-1.5 w-1.5 rounded-full ${c.dot}`}
                    />
                    {label}
                  </span>
                  <span className="text-sm text-slate-400">using <span className="font-medium text-white">{browser}</span></span>
                </div>

                <ol className="space-y-4">
                  {instructions.map(({ step, text }) => (
                    <li key={step} className="flex items-start gap-4">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${c.num}`}
                      >
                        {step}
                      </span>
                      <p className="pt-0.5 text-sm leading-6 text-slate-300">{text}</p>
                    </li>
                  ))}
                </ol>
              </div>
            );
          })}
        </div>

        {/* Tip box */}
        <div className="mt-10 rounded-2xl border border-white/10 bg-white/5 px-6 py-5 panel-lift">
          <p className="text-sm font-semibold text-white mb-1">Tip</p>
          <p className="text-sm leading-6 text-slate-400">
            Once added, the shortcut will appear on your home screen and open the site in full-screen mode, just like a native app — no browser chrome shown.
          </p>
        </div>

      </div>
    </div>
  );
}
